import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

export enum SscIconHierarchy {
  primary = 'primary',
  inverted = 'inverted',
  basic = 'basic',
}

@Component({
  selector: 'ssc-icon',
  templateUrl: './ssc-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['ssc-icon.component.scss'],
  host: {
    '[class.ssc-icon--basic]': 'hierarchy() === iconHierarchy.basic',
    '[class.ssc-icon--dark]': 'dark()',
    '[class.ssc-icon--force-dark]': 'forceDark()',
    '[class.ssc-icon--force-light]': 'forceLight()',
  },
})
export class SscIconComponent {
  dark = input(false, { transform: booleanAttribute });
  forceDark = input(false, { transform: booleanAttribute });
  forceLight = input(false, { transform: booleanAttribute });
  fill = input(false, { transform: booleanAttribute });
  regular = input(false, { transform: booleanAttribute });
  small = input(false, { transform: booleanAttribute });

  size = input<string>();

  iconHierarchy = SscIconHierarchy;
  svg = input<string>();
  hierarchy = input<SscIconHierarchy>(SscIconHierarchy.basic);

  iconClass = computed(() => {
    const name = this.svg();
    if (!name) {
      return '';
    }

    return `ph-${name}`;
  });

  private iconWeightClass = computed(() => {
    if (this.fill()) {
      return 'ph-fill';
    }

    if (this.regular()) {
      return 'ph';
    }

    return 'ph-bold';
  });

  primaryIconClasses = computed(
    () =>
      `${this.iconWeightClass()} ${this.iconClass()} p-1 rounded-xl h-10 w-10 flex justify-center items-center text-3xl text-text-faint dark:text-text-dark`,
  );

  invertedIconClasses = computed(
    () =>
      `${this.iconWeightClass()} ${this.iconClass()} p-1 rounded-xl h-10 w-10 flex justify-center items-center text-3xl text-text-dark dark:text-text-faint`,
  );

  basicIconClasses = computed(
    () =>
      `${this.iconWeightClass()} ${this.iconClass()} p-1 rounded-xl flex justify-center items-center text-inherit ${this.basicDimensions()}`,
  );

  basicDimensions = computed(() => {
    if (this.size()) {
      return this.size();
    }

    if (!this.small()) {
      return 'h-8 w-8 text-3xl';
    } else {
      return 'h-4 w-4 text-xl';
    }
  });
}
